<section class="nw_service_th" *ngIf="businessListData.length > 0">
  <div class="service_se">
    <div class="heading_sert">
      <h3>All Bookings / Activity</h3>
    </div>
    <div class="chip_services_list">
      <mat-chip-list>
        <mat-chip
          (click)="selectBusiness(i)"
          *ngFor="let item of businessListData; let i = index"
          [ngClass]="{ 'Graceful-box-active': item.isSelected == 1 }"
          >{{ item.name }}</mat-chip
        >
      </mat-chip-list>
    </div>
  </div>

  <div class="service_create_sd">
    <div class="row" *ngIf="selectedBusiness.revenue_model == 1">
      <div class="col-sm-5">
        <div class="">
          <div class="serv_heading">
            <h3>
              {{
                  selectedValueForBeauty == "1"
                    ? "Bookings"
                    : selectedValueForBeauty == "2"
                    ? "Membership requests"
                    : "Queries"
                  
              }}
              of {{ selectedBusiness.name }}
            </h3>
            <p>{{ selectedBusiness.address_line }}</p>
          </div>
        </div>
      </div>
      <div class="col-sm-7">
        <div class="date-range-form">
          <div class="nw_all">
            <mat-form-field
              appearance="outline"
              (click)="fromDatePicker.open()"
            >
              <mat-label>From Date</mat-label>
              <input
                matInput
                [matDatepicker]="fromDatePicker"
                [(ngModel)]="fromDate"
                readonly
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="fromDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #fromDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="nw_all">
            <mat-form-field appearance="outline" (click)="toDatePicker.open()">
              <mat-label>To Date</mat-label>
              <input
                matInput
                [matDatepicker]="toDatePicker"
                [(ngModel)]="toDate"
                readonly
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="toDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #toDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="search_pag">
            <button
              (click)="search()"
              mat-flat-button
              color="primary"
              type="submit"
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="selectedBusiness.revenue_model == 2">
      <div class="col-sm-5">
        <div class="">
          <div class="serv_heading">
            <h3>
              {{
                selectedBusiness.revenue_model == 1
                  ? "Appointments"
                  : selectedBusiness.revenue_model == 2
                  ? selectedValue == "1"
                    ? "Membership requests"
                    : selectedValue == "2"
                    ? "Session bookings"
                    : selectedValue == '4' ? 'Queries' : "Attendances"
                  : ""
              }}
              of {{ selectedBusiness.name }}
            </h3>
            <p>{{ selectedBusiness.address_line }}</p>
          </div>
        </div>
      </div>
      <div class="col-sm-7">
        <div class="date-range-form">
          <div class="nw_all">
            <mat-form-field
              appearance="outline"
              (click)="fromDatePicker.open()"
            >
              <mat-label>From Date</mat-label>
              <input
                matInput
                [matDatepicker]="fromDatePicker"
                [(ngModel)]="fromDate"
                readonly
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="fromDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #fromDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="nw_all">
            <mat-form-field appearance="outline" (click)="toDatePicker.open()">
              <mat-label>To Date</mat-label>
              <input
                matInput
                [matDatepicker]="toDatePicker"
                [(ngModel)]="toDate"
                readonly
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="toDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #toDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="search_pag">
            <button
              (click)="search()"
              mat-flat-button
              color="primary"
              type="submit"
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div
    *ngIf="selectedBusiness.revenue_model == 1"
    style="margin-bottom: 20px; display: flex; justify-content: space-between"
  >
    <div class="chip_services_list">
      <mat-chip-list>
        <mat-chip
          [ngClass]="{ 'Graceful-box-active': selectedValueForBeauty == '1' }"
          (click)="changeChipForBeauty('1')"
          >Bookings</mat-chip
        >
        <mat-chip
          [ngClass]="{ 'Graceful-box-active': selectedValueForBeauty == '2' }"
          (click)="changeChipForBeauty('2')"
          >Membership request</mat-chip
        >
        <mat-chip
          [ngClass]="{ 'Graceful-box-active': selectedValueForBeauty == '3' }"
          (click)="changeChipForBeauty('3')"
          >Customer queries
        </mat-chip>
      </mat-chip-list>
    </div>
    <div class="booking_sectionkl">
      <!-- <div class="Create_header_btn">
        <button
        *ngIf="isAccessForEmployeeInvoice"
          mat-flat-button
          color="primary"
          (click)="createNewBookingFromList()"
        >
          <mat-icon>add</mat-icon> Booking
        </button>
      </div> -->

        <!-- new button add -->
           <div class="Create_header_btn">
        <button
          mat-flat-button
          color="primary"
          [matMenuTriggerFor]="addMenu">
          <mat-icon>add</mat-icon>
          Add new
        </button>
        </div>
        <!-- Menu -->
        <mat-menu #addMenu="matMenu">
          <button mat-menu-item (click)="createNewBookingFromList()">
            <mat-icon>event</mat-icon>
            <span>New booking</span>
          </button>
          <button mat-menu-item (click)="addNewInterestFromList()">
            <mat-icon>card_membership</mat-icon>
            <span>New membership request</span>
          </button>
        </mat-menu>
      <!-- end new button -->



      <!-- <div class="Create_header_btn">
        <button
        *ngIf="isAccessForEmployeeInvoice"
          mat-flat-button
          color="primary"
          (click)="addNewInterestFromList()"
        >
          <mat-icon>add</mat-icon> Query
        </button>
      </div> -->
    </div>
  </div>
  <div
    *ngIf="selectedBusiness.revenue_model == 2"
    style="margin-bottom: 20px; display: flex; justify-content: space-between"
  >
    <div class="chip_services_list">
      <mat-chip-list>
        <mat-chip
          [ngClass]="{ 'Graceful-box-active': selectedValue == '3' }"
          (click)="changeChip('3')"
          >Attendance</mat-chip
        >
        <mat-chip
          [ngClass]="{ 'Graceful-box-active': selectedValue == '2' }"
          (click)="changeChip('2')"
          >Session Booking</mat-chip
        >
        <mat-chip
          [ngClass]="{ 'Graceful-box-active': selectedValue == '1' }"
          (click)="changeChip('1')"
          >Membership request
        </mat-chip>
        <mat-chip
          [ngClass]="{ 'Graceful-box-active': selectedValue == '4' }"
          (click)="changeChip('4')"
          >Customer queries
        </mat-chip>
      </mat-chip-list>
    </div>
    <div class="booking_sectionkl">
      <!-- <div class="Create_header_btn">
        <button
        *ngIf="isAccessForEmployeeInvoice"
          mat-flat-button
          color="primary"
          (click)="createNewBookingFromList()"
        >
          <mat-icon>add</mat-icon> Booking
        </button>
      </div>

      <div class="Create_header_btn">
        <button
        *ngIf="isAccessForEmployeeInvoice"
          mat-flat-button
          color="primary"
          (click)="addNewInterestFromList()"
        >
          <mat-icon>add</mat-icon> Query
        </button>
      </div> -->

      <!-- new button add -->
           <div class="Create_header_btn">
        <button
          mat-flat-button
          color="primary"
          [matMenuTriggerFor]="addMenu">
          <mat-icon>add</mat-icon>
          Add new
        </button>
        </div>
        <!-- Menu -->
        <mat-menu #addMenu="matMenu">
          <button mat-menu-item (click)="createNewBookingFromList()">
            <mat-icon>event</mat-icon>
            <span>New booking</span>
          </button>
          <button mat-menu-item (click)="addNewInterestFromList()">
            <mat-icon>card_membership</mat-icon>
            <span>New membership request</span>
          </button>
        </mat-menu>
      <!-- end new button -->

    </div>
  </div>
  <!-- Beauty bookings code start -->
  <mat-card
    *ngIf="
      selectedBusiness.revenue_model == 1 && bookingsList.length > 0 && !loader && selectedValueForBeauty == '1'
    "
  >
    <div class="schedule-container">
      <div class="table-container">
        <mat-table [dataSource]="bookingsList" class="mat-elevation-z8">
          <ng-container matColumnDef="date">
            <mat-header-cell *matHeaderCellDef> Date </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.bookingDate | date }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="customerName">
            <mat-header-cell *matHeaderCellDef> Customer Name </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.customerName }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="noOfServices">
            <mat-header-cell *matHeaderCellDef>
              No. Of Services
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.servicesCount }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="cost">
            <mat-header-cell *matHeaderCellDef> Cost </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.price }} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="paymentStatus">
            <mat-header-cell *matHeaderCellDef>
              Payment Status
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.paymentStat }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="startTime">
            <mat-header-cell *matHeaderCellDef> Start Time </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.bookingStartTime }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="endTime">
            <mat-header-cell *matHeaderCellDef> End Time </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.bookingEndTime }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="assignedTo">
            <mat-header-cell *matHeaderCellDef> Assigned To </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.employeeName }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="bookingType">
            <mat-header-cell *matHeaderCellDef> Booking Type </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.booking_type }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="bookingStatus">
            <mat-header-cell *matHeaderCellDef>
              Booking Status
            </mat-header-cell>
            <mat-cell
              *matCellDef="let element"
              [class.new-booking]="
                element.bookingStatus == 0 ||
                element.bookingStatus == 1 ||
                element.bookingStatus == 2
              "
              [class.under-process]="
                element.bookingStatus == 3 ||
                element.bookingStatus == 7 ||
                element.bookingStatus == 9
              "
              [class.completed]="element.bookingStatus == 4"
              [class.cancelled]="
                element.bookingStatus == 6 || element.bookingStatus == 8
              "
              [class.confirmed]="element.bookingStatus == 5"
            >
              {{ element.bookingStat }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element" class="menu-cell">
              <div class="icon-wrapper">
                <button mat-icon-button class="custom-icon-button">
                  <mat-icon>arrow_forward</mat-icon>
                </button>
              </div>
              <mat-menu #menu="matMenu">
                <button mat-menu-item>
                  <mat-icon class="material-icons-outlined">info</mat-icon>
                  <span>Booking details</span>
                </button>
                <!-- <button mat-menu-item (click)="confirmBooking(element)" *ngIf="(((element.bookingStatus == 0 || element.bookingStatus == 1 || element.bookingStatus == 2) && (element.customerInfo.hash_id && element.customerInfo.hash_id != 'null')) && (element.toshowOptions == 1))">
                        <mat-icon class="material-icons-outlined">check_circle</mat-icon>
                        <span>Confirm booking</span>
                    </button>
                    <button mat-menu-item *ngIf="element.bookingStatus == 4 && selectedBusiness.is_owner == 1" (click)="openInvoice(element)">
                        <mat-icon class="material-icons-outlined">badge</mat-icon>
                        <span>Invoice</span>
                    </button>
                    <button mat-menu-item (click)="cancelBooking(element)" *ngIf="(((element.bookingStatus == 0 || element.bookingStatus == 1 || element.bookingStatus == 2 || element.bookingStatus == 5)) && (element.toshowOptions == 1 && selectedBusiness.is_owner == 1))">
                        <mat-icon class="material-icons-outlined">cancel</mat-icon>
                        <span>Cancel booking</span>
                    </button>
                    <button mat-menu-item *ngIf="(!element.customerInfo.hash_id || element.customerInfo.hash_id == 'null') && selectedBusiness.is_owner == 1" (click)="deleteBooking(element)">
                      <mat-icon class="material-icons-outlined">delete</mat-icon>
                      <span>Delete booking</span>
                    </button> -->
              </mat-menu>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row
            *matRowDef="let row; columns: displayedColumns"
            (click)="bookingDetails(row)"
          ></mat-row>
        </mat-table>
      </div>
    </div>
  </mat-card>

  <!-- Beauty bookings code end -->

  <!-- QUERIES START -->

  <div
    *ngIf="
      (selectedBusiness.revenue_model == 2 &&
      selectedValue == '1' &&
      interestData.length > 0 &&
      !loader) || (selectedBusiness.revenue_model == 1 &&
      selectedValueForBeauty == '2' &&
      interestData.length > 0 &&
      !loader)
    "
  >
    <mat-card>
      <div class="rounded-3 bg-light">
        <sm-data-table-for-appointments
          [columnHeaders]="tableDisplayColumns"
          [dataSource]="interestData"
          [showPagination]="true"
          [itemsPerPage]="25"
          [showMenuButton]="true"
          [menuDropdownTemplate]="menuTemplate"
          [rowClickHandler]="rowClickHandler"
        >
          <ng-template #costTemplate let-rowVal="row" let-colVal="col">
            adas
          </ng-template>
        </sm-data-table-for-appointments>
      </div>
    </mat-card>
    <ng-template #menuTemplate let-rowvalue>
      <button mat-menu-item (click)="viewDetails(rowvalue)">
        <mat-icon class="material-icons-outlined">info</mat-icon>
        <span>Query details</span>
      </button>
      <!-- <button mat-menu-item (click)="changeRequestStatus(rowvalue,1)" *ngIf="rowvalue.enrollment_request_status != 1 &&  rowvalue.enrollment_request_status != 5 && selectedBusiness.is_owner == 1">
            <mat-icon class="material-icons-outlined">grade</mat-icon>
            <span>Mark as new</span>
            </button>
           <button mat-menu-item (click)="changeRequestStatus(rowvalue,2)" *ngIf="rowvalue.enrollment_request_status != 2 &&  rowvalue.enrollment_request_status != 5 && selectedBusiness.is_owner == 1">
            <mat-icon class="material-icons-outlined">hourglass_top</mat-icon>
            <span>Mark as in-progress</span>
            </button>
            <button mat-menu-item (click)="changeRequestStatus(rowvalue,3)" *ngIf="rowvalue.enrollment_request_status != 3 &&  rowvalue.enrollment_request_status != 5  && selectedBusiness.is_owner == 1">
            <mat-icon class="material-icons-outlined">task_alt</mat-icon>
            <span>Mark as enrolled</span>
            </button>
            <button mat-menu-item (click)="changeRequestStatus(rowvalue,4)" *ngIf="rowvalue.enrollment_request_status != 4 &&  rowvalue.enrollment_request_status != 5 && selectedBusiness.is_owner == 1">
            <mat-icon class="material-icons-outlined">cancel</mat-icon>
            <span>Mark as cancelled</span>
            </button>
           
            <button mat-menu-item (click)="deleteQuery(rowvalue)" *ngIf="(!rowvalue.customer_account_hash ||  rowvalue.customer_account_hash == 'null') && selectedBusiness.is_owner == 1">
            <mat-icon class="material-icons-outlined">delete</mat-icon>
            <span> Delete query</span>
            </button> -->
    </ng-template>
  </div>

  <!-- QUERIES END -->

  <!-- fitness book appointment code start-->

  <div
    class="schedule-container"
    *ngIf="
      !loader &&
      messageList.length > 0 &&
      selectedBusiness.revenue_model == 2 &&
      selectedValue == '2'
    "
  >
    <div class="table-container">
      <mat-table [dataSource]="messageList" class="mat-elevation-z1">
        <ng-container matColumnDef="date">
          <mat-header-cell *matHeaderCellDef> Date </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.booking_date ? (element.booking_date | date) : "---" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="customerName">
          <mat-header-cell *matHeaderCellDef> Customer Name </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.customerName }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="noOfServices">
          <mat-header-cell *matHeaderCellDef> No. Of Services </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.servicesCount }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="cost">
          <mat-header-cell *matHeaderCellDef> Cost </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.price }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="paymentStatus">
          <mat-header-cell *matHeaderCellDef> Payment Status </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.paymentStat }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="startTime">
          <mat-header-cell *matHeaderCellDef> Start Time </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.bookingStartTime }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="endTime">
          <mat-header-cell *matHeaderCellDef> End Time </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.bookingEndTime }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="assignedTo">
          <mat-header-cell *matHeaderCellDef> Assigned To </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.employeeName }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="bookingType">
          <mat-header-cell *matHeaderCellDef> Booking Type </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.booking_type }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="bookingStatus">
          <mat-header-cell *matHeaderCellDef> Booking Status </mat-header-cell>
          <mat-cell
            *matCellDef="let element"
            [class.new-booking]="
              element.bookingStatus == 0 ||
              element.bookingStatus == 1 ||
              element.bookingStatus == 2
            "
            [class.under-process]="
              element.bookingStatus == 3 ||
              element.bookingStatus == 7 ||
              element.bookingStatus == 9
            "
            [class.completed]="element.bookingStatus == 4"
            [class.cancelled]="
              element.bookingStatus == 6 || element.bookingStatus == 8
            "
            [class.confirmed]="element.bookingStatus == 5"
          >
            {{ element.bookingStat }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef> </mat-header-cell>
          <mat-cell *matCellDef="let element" class="menu-cell">
            <div class="icon-wrapper">
              <button mat-icon-button class="custom-icon-button">
                <mat-icon>arrow_forward</mat-icon>
              </button>
            </div>

            <mat-menu #menu2="matMenu">
              <div *ngIf="element.data_type == 1">
                <button
                  mat-menu-item
                  (click)="bookingDetailsForHistory(element)"
                >
                  <mat-icon class="material-icons-outlined">info</mat-icon>
                  <span>Booking details</span>
                </button>
                <!-- <button mat-menu-item (click)="confirmBookingForHistory(element)" *ngIf="(((element.bookingStatus == 0 || element.bookingStatus == 1 || element.bookingStatus == 2) && (element.customerInfo.hash_id && element.customerInfo.hash_id != 'null')) && (element.toshowOptions == 1))">
                      <mat-icon class="material-icons-outlined">check_circle</mat-icon>
                      <span>Confirm booking</span>
                  </button>
                  <button mat-menu-item *ngIf="element.bookingStatus == 4 && selectedBusiness.is_owner == 1" (click)="openInvoiceForHistory(element)">
                      <mat-icon class="material-icons-outlined">badge</mat-icon>
                      <span>Invoice</span>
                  </button>
                  <button mat-menu-item (click)="cancelBookingForHistory(element)" *ngIf="(((element.bookingStatus == 0 || element.bookingStatus == 1 || element.bookingStatus == 2 || element.bookingStatus == 5)) && (element.toshowOptions == 1 && selectedBusiness.is_owner == 1))">
                      <mat-icon class="material-icons-outlined">cancel</mat-icon>
                      <span>Cancel booking</span>
                  </button>
                  <button mat-menu-item *ngIf="(!element.customerInfo.hash_id || element.customerInfo.hash_id == 'null') && selectedBusiness.is_owner == 1" (click)="deleteBookingForHistory(element)">
                    <mat-icon class="material-icons-outlined">delete</mat-icon>
                    <span>Delete booking</span>
                  </button> -->
              </div>

              <div *ngIf="element.data_type == 2">
                <button
                  mat-menu-item
                  (click)="changeAttendanceStatus(1, element)"
                  *ngIf="
                    element.bookingStatus == 0 ||
                    element.bookingStatus == null ||
                    element.bookingStatus == 'null'
                  "
                  [disabled]="selectedBusiness.is_owner == 0"
                >
                  <mat-icon class="material-icons-outlined"
                    >check_circle</mat-icon
                  >
                  <span>mark as present</span>
                </button>
                <button
                  mat-menu-item
                  (click)="changeAttendanceStatus(0, element)"
                  *ngIf="
                    element.bookingStatus == 1 ||
                    element.bookingStatus == null ||
                    element.bookingStatus == 'null'
                  "
                  [disabled]="selectedBusiness.is_owner == 0"
                >
                  <mat-icon class="material-icons-outlined">cancel</mat-icon>
                  <span>mark as absent</span>
                </button>
                <button
                  mat-menu-item
                  *ngIf="
                    element.bookingStatus == 0 || element.bookingStatus == 1
                  "
                  (click)="deleteAttendance(element)"
                  [disabled]="selectedBusiness.is_owner == 0"
                >
                  <mat-icon class="material-icons-outlined">delete</mat-icon>
                  <span>Delete attendance</span>
                </button>
              </div>
            </mat-menu>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedColumns"
          (click)="bookingDetailsForHistory(row)"
        ></mat-row>
      </mat-table>
    </div>
  </div>

  <!-- fitness book appointment code end -->

  <!-- fitness attendance code start -->

  <div
    class="schedule-container"
    *ngIf="
      !loader &&
      attendanceList.length > 0 &&
      selectedBusiness.revenue_model == 2 &&
      selectedValue == '3'
    "
  >
    <div class="table-container">
      <mat-table [dataSource]="attendanceList" class="mat-elevation-z1">
        <ng-container matColumnDef="date">
          <mat-header-cell *matHeaderCellDef> Date </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.booking_date ? (element.booking_date | date) : "---" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="customerName">
          <mat-header-cell *matHeaderCellDef> Customer Name </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.customerName }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="noOfServices">
          <mat-header-cell *matHeaderCellDef> No. Of Services </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.servicesCount }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="cost">
          <mat-header-cell *matHeaderCellDef> Cost </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.price }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="paymentStatus">
          <mat-header-cell *matHeaderCellDef> Payment Status </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.paymentStat }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="startTime">
          <mat-header-cell *matHeaderCellDef> Start Time </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.bookingStartTime }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="endTime">
          <mat-header-cell *matHeaderCellDef> End Time </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.bookingEndTime }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="assignedTo">
          <mat-header-cell *matHeaderCellDef> Assigned To </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.employeeName }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="bookingType">
          <mat-header-cell *matHeaderCellDef> Booking Type </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.booking_type }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="bookingStatus">
          <mat-header-cell *matHeaderCellDef> Booking Status </mat-header-cell>
          <mat-cell
            *matCellDef="let element"
            [class.cancelled]="
              element.bookingStatus == 0 && element.data_type == 2
            "
            [class.new-booking]="
              element.bookingStatus == 1 &&
              !element.session_status &&
              element.data_type == 2
            "
            [class.under-process]="
              element.bookingStatus == 1 &&
              (element.session_status == 2 || element.session_status == 1) &&
              element.data_type == 2
            "
            [class.completed]="
              element.bookingStatus == 1 &&
              element.session_status == 3 &&
              element.data_type == 2
            "
          >
            {{ element.bookingStat }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <button
              mat-icon-button
              [matMenuTriggerFor]="menu2"
              class="custom-icon-button"
            >
              <mat-icon>more_vert</mat-icon>
            </button>

            <mat-menu #menu2="matMenu">
              <div *ngIf="element.data_type == 2">
                <button
                  mat-menu-item
                  (click)="changeAttendanceStatus(1, element)"
                  *ngIf="
                    element.bookingStatus == 0 ||
                    element.bookingStatus == null ||
                    element.bookingStatus == 'null'
                  "
                  [disabled]="selectedBusiness.is_owner == 0"
                >
                  <mat-icon class="material-icons-outlined"
                    >check_circle</mat-icon
                  >
                  <span>mark as present</span>
                </button>
                <button
                  mat-menu-item
                  (click)="changeAttendanceStatus(0, element)"
                  *ngIf="
                    element.bookingStatus == 1 ||
                    element.bookingStatus == null ||
                    element.bookingStatus == 'null'
                  "
                  [disabled]="selectedBusiness.is_owner == 0"
                >
                  <mat-icon class="material-icons-outlined">cancel</mat-icon>
                  <span>mark as absent</span>
                </button>
                <button
                  mat-menu-item
                  *ngIf="
                    element.bookingStatus == 0 || element.bookingStatus == 1
                  "
                  (click)="deleteAttendance(element)"
                  [disabled]="selectedBusiness.is_owner == 0"
                >
                  <mat-icon class="material-icons-outlined">delete</mat-icon>
                  <span>Delete attendance</span>
                </button>
              </div>
            </mat-menu>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
    </div>
  </div>

  <!-- fitness attendance code end -->

  <!-- Placeholder design html start -->
  <div
    class="placeholder_started"
    *ngIf="
      bookingsList.length == 0 &&
      interestData.length == 0 &&
      messageList.length == 0 &&
      !loader &&
      selectedValue != '3' && selectedValue != '4' && selectedValueForBeauty != '3'
    "
  >
    <div class="row">
      <!-- <div class="heading_sert">
            <h3>All bookings</h3>
        </div> -->
      <!-- <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/s3.png">
                 </div>
                 <mat-card-title>No business added yet yet</mat-card-title>
                 <mat-card-content>Booking list will appear hear. For that you need to create a business first. It's easy and takes only 2 minutes.
                </mat-card-content>
                 <div class="create_btnyh">
                    <button mat-flat-button color="primary">
                        <mat-icon>add</mat-icon> 
                        Create new 
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div> -->
      <div class="col-sm-4" *ngIf="selectedBusiness.revenue_model == 1">
        <div class="dashboard_new">
          <mat-card>
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="./assets/images/booking-history-1.jpg" />
              </div>
              <mat-card-title>No booking to show.</mat-card-title>
              <mat-card-content
                >All the bookings will appear here between the selected date
                range. It seems you haven't started operations or check the
                selected dates.
              </mat-card-content>
              <!-- <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary" (click)="openvideo()">
                       <mat-icon>play_arrow</mat-icon>
                       Watch video
                    </button>
                 </div> -->
            </div>
          </mat-card>
        </div>
      </div>
      <div class="col-sm-4" *ngIf="selectedBusiness.revenue_model == 1">
        <div class="dashboard_new">
          <mat-card>
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="/assets/images/new-booking.png" />
              </div>
              <mat-card-title>How to create a new booking?</mat-card-title>
              <mat-card-content
                >Check our
                <span
                  class="ghtunderline"
                  (click)="openLink('https://lookzup.com/help')"
                >
                  help document
                </span>
                on creating new booking against a business. You can check this
                video as well.
              </mat-card-content>
              <div class="watch_vc_btn">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="openvideo()"
                >
                  <mat-icon>play_arrow</mat-icon>
                  Watch video
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>

      <div class="col-sm-4" *ngIf="selectedBusiness.revenue_model == 2">
        <div class="dashboard_new">
          <mat-card>
            <div class="upload_sectio">
              <div class="icm_img" *ngIf="selectedValue == 2">
                <img src="./assets/images/booking-history-1.jpg" />
              </div>
              <div class="icm_img" *ngIf="selectedValue == 1">
                <img src="./assets/images/query-s1.jpg" />
              </div>
              <mat-card-title *ngIf="selectedValue == 2"
                >No bookings to show here.</mat-card-title
              >
              <mat-card-title *ngIf="selectedValue == 1"
                >No queries to show here.</mat-card-title
              >

              <mat-card-content *ngIf="selectedValue == 2"
                >All the bookings will appear here between the selected date
                range. It seems you haven't started operations or check the
                selected dates.
              </mat-card-content>
              <mat-card-content *ngIf="selectedValue == 1"
                >All the queries will appear here between the selected date
                range. It seems you haven't started operations or check the
                selected dates.
              </mat-card-content>
            </div>
          </mat-card>
        </div>
      </div>
      <div
        class="col-sm-4"
        *ngIf="selectedBusiness.revenue_model == 2 && selectedValue == '1'"
      >
        <div class="dashboard_new">
          <mat-card appearance="outlined">
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="/assets/images/new-booking.png" />
              </div>
              <mat-card-title>How to create a new query?</mat-card-title>
              <mat-card-content
                >Check our
                <span
                  class="ghtunderline"
                  (click)="openLink('https://lookzup.com/help')"
                >
                  help document
                </span>
                on creating new query against a business. You can check this
                video as well.
              </mat-card-content>
              <div class="watch_vc_btn">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="openvideo()"
                >
                  <mat-icon>play_arrow</mat-icon>
                  Watch video
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div
        class="col-sm-4"
        *ngIf="selectedBusiness.revenue_model == 2 && selectedValue == '2'"
      >
        <div class="dashboard_new">
          <mat-card appearance="outlined">
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="/assets/images/new-booking.png" />
              </div>
              <mat-card-title>How to create a new booking?</mat-card-title>
              <mat-card-content
                >Check our
                <span
                  class="ghtunderline"
                  (click)="openLink('https://lookzup.com/help')"
                >
                  help document
                </span>
                on creating new booking against a business. You can check this
                video as well.
              </mat-card-content>
              <div class="watch_vc_btn">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="openvideo()"
                >
                  <mat-icon>play_arrow</mat-icon>
                  Watch video
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div class="col-sm-4" *ngIf="selectedBusiness.revenue_model == 2">
        <div class="dashboard_new">
          <mat-card>
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="./assets/images/helpsupport.png" />
              </div>
              <mat-card-title>Having any issue?</mat-card-title>
              <mat-card-content *ngIf="selectedValue == 2"
                >For any difficulties in displaying data here or if there's any
                issue while creating booking, contact our support team.
              </mat-card-content>
              <mat-card-content *ngIf="selectedValue == 1"
                >For any difficulties in adding a new query or issue with
                managing them, contact our support team.
              </mat-card-content>
              <div class="watch_vc_btn">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="opencontact()"
                >
                  <mat-icon>support_agent</mat-icon>
                  Contact support
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div class="col-sm-4" *ngIf="selectedBusiness.revenue_model == 1">
        <div class="dashboard_new">
          <mat-card>
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="./assets/images/helpsupport.png" />
              </div>
              <mat-card-title>Having any issue?</mat-card-title>
              <mat-card-content
                >For any difficulties in displaying data here or if there's any
                issue while creating booking, contact our support team.
              </mat-card-content>
              <div class="watch_vc_btn">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="opencontact()"
                >
                  <mat-icon>support_agent</mat-icon>
                  Contact support
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
  <!-- Placeholder design html start -->

  <!-- Placeholder design html start for attendance -->
  <div
    class="placeholder_started"
    *ngIf="
      attendanceList.length == 0 &&
      selectedBusiness.revenue_model == 2 &&
      selectedValue == '3' &&
      !loader
    "
  >
    <div class="row">
      <!-- <div class="heading_sert">
                <h3>All bookings</h3>
            </div> -->
      <!-- <div class="col-sm-4">
                <div class="dashboard_new">
                  <mat-card>
                      <div class="upload_sectio">
                     <div class="icm_img">
                        <img src="./assets/images/s3.png">
                     </div>
                     <mat-card-title>No business added yet yet</mat-card-title>
                     <mat-card-content>Booking list will appear hear. For that you need to create a business first. It's easy and takes only 2 minutes.
                    </mat-card-content>
                     <div class="create_btnyh">
                        <button mat-flat-button color="primary">
                            <mat-icon>add</mat-icon> 
                            Create new 
                        </button>
                     </div>
                     </div>
                  </mat-card>
               </div>
              </div> -->

      <div class="col-sm-4">
        <div class="dashboard_new">
          <mat-card appearance="outlined">
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="./assets/images/booking-history-1.jpg" />
              </div>

              <mat-card-title>No attendance list to show here.</mat-card-title>

              <mat-card-content
                >All the attendances will appear here between the selected date
                range. It seems you haven't started operations or check the
                selected dates.
              </mat-card-content>
            </div>
          </mat-card>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="dashboard_new">
          <mat-card appearance="outlined">
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="/assets/images/new-booking.png" />
              </div>
              <mat-card-title>How attendance work?</mat-card-title>
              <mat-card-content
                >Check our
                <span
                  class="ghtunderline"
                  (click)="openLink('https://lookzup.com/help')"
                >
                  help document
                </span>
                on marking present and absent against members. You can check
                this video as well.
              </mat-card-content>
              <div class="watch_vc_btn">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="openVideoForAttendance()"
                >
                  <mat-icon>play_arrow</mat-icon>
                  Watch video
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="dashboard_new">
          <mat-card appearance="outlined">
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="./assets/images/helpsupport.png" />
              </div>
              <mat-card-title>Having any issue?</mat-card-title>
              <mat-card-content
                >For any difficulties in displaying data here or if there's any
                issue while creating booking, contact our support team.
              </mat-card-content>
              <div class="watch_vc_btn">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="opencontact()"
                >
                  <mat-icon>support_agent</mat-icon>
                  Contact support
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
  <!-- Placeholder design html end for attendance -->
</section>
<section class="nw_service_th" *ngIf="!loader && businessListData.length == 0">
  <!-- Placeholder design html start -->
  <div class="placeholder_started">
    <div class="row">
      <div class="heading_sert">
        <h3>All bookings</h3>
      </div>
      <div
        class="col-sm-4"
        *ngIf="!isEmployeeAndHasBusinessButDoesNotHaveAccess"
      >
        <div class="dashboard_new">
          <mat-card>
            <div class="upload_sectio">
              <div class="icm_img">
                <img
                  src="./assets/images/business-create.png"
                  style="width: 110px"
                />
              </div>
              <mat-card-title>No business added yet</mat-card-title>
              <mat-card-content
                >Booking list will appear here. For that you need to create a
                business first. It's easy and takes only 2 minutes.
              </mat-card-content>
              <div class="create_btnyh">
                <button
                  mat-flat-button
                  color="primary"
                  (click)="selectcountry()"
                >
                  <mat-icon>add</mat-icon>
                  Create a business
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div
        class="col-sm-4"
        *ngIf="isEmployeeAndHasBusinessButDoesNotHaveAccess"
      >
        <div class="dashboard_new">
          <mat-card appearance="outlined" style="">
            <div class="upload_sectio">
              <div class="icm_img">
                <img
                  src="./assets/images/business-create.png"
                  style="width: 110px"
                />
              </div>
              <mat-card-title>Access denied.</mat-card-title>
              <mat-card-content>
                Business owner with valid premium business subscription or an
                active employee can access this section. Check current plans.
                Recharge pack if expired.
              </mat-card-content>
            </div>
          </mat-card>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="dashboard_new">
          <mat-card>
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="./assets/images/booking-history-1.jpg" />
              </div>
              <mat-card-title>No booking to show here</mat-card-title>
              <mat-card-content
                >All the bookings will appear here between the selected date
                range. It seems you haven't started operations or check the
                selected dates.
              </mat-card-content>
              <div class="watch_vc_btn">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="openvideo()"
                >
                  <mat-icon>play_arrow</mat-icon>
                  Watch video
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="dashboard_new">
          <mat-card>
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="./assets/images/helpsupport.png" />
              </div>
              <mat-card-title>Having any issue?</mat-card-title>
              <mat-card-content
                >For any difficulties in displaying data here or if there's any
                issue while creating booking, contact our support team.
              </mat-card-content>
              <div class="watch_vc_btn">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="opencontact()"
                >
                  <mat-icon>support_agent</mat-icon>
                  Contact support
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
  <!-- Placeholder design html start -->
</section>




  <!--  QUERIES START -->
<mat-card style="margin-bottom: 10px;" *ngIf="!loader && queryData.length > 0  && (selectedValueForBeauty == '3' || selectedValue == '4')">

   <div class="rounded-3 bg-light" >
      <sm-data-table-for-appointments
      [columnHeaders]="tableDisplayColumnsforserviceQuery"
      [dataSource]="queryData"
      [showPagination]="true"
      [itemsPerPage]="25"
      [showMenuButton]="true"
      [menuDropdownTemplate]="menuTemplate"
      [rowClickHandler]="rowClickHandlerforservicequery"
      >
      <ng-template #costTemplate let-rowVal="row" let-colVal="col">
        adas
      </ng-template>
      </sm-data-table-for-appointments>
   </div>
</mat-card>


<ng-template #menuTemplate let-rowvalue>
   <div>
   <button mat-menu-item (click)="viewDetails(rowvalue)">
      <mat-icon class="material-icons-outlined">info</mat-icon>
      <span>View details</span>
      </button>
  
</div>
 

</ng-template>
<!-- placeholder html start -->
<div class="placeholder_started" *ngIf="!loader && queryData.length == 0  && (selectedValueForBeauty == '3' || selectedValue == '4')">
   <div class="row">
      <div class="col-sm-4" >
         <div class="dashboard_new">
            <mat-card>
               <div class="upload_sectio">
                  <div class="icm_img">
                     <img src="./assets/images/query-s1.jpg">
                  </div>
                  <mat-card-title>No service queries to show.</mat-card-title>
                  <mat-card-content>All the queries will appear here between the selected date range. It seems you haven't started operations or check the selected dates.
                  </mat-card-content>
                  <!-- <div class="watch_vc_btn" *ngIf="interestType != '4'">
                     <button mat-stroked-button color="primary"  (click)="addNewInterest()">
                        <mat-icon>add</mat-icon>
                        Add new query 
                     </button>
                  </div> -->
               </div>
            </mat-card>
         </div>
      </div>

      <!-- <div class="col-sm-4">
         <div class="dashboard_new">
           <mat-card>
               <div class="upload_sectio">
              <div class="icm_img">
                 <img src="/assets/images/new-booking.png">
              </div>
              <mat-card-title>How to create a new query?</mat-card-title>
              <mat-card-content>Check our <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')"> help document </span> on creating new query against a business. You can check this video as well. 

             </mat-card-content>
             <div class="watch_vc_btn">
               <button mat-stroked-button color="primary" (click)="openvideo()">
                  <mat-icon>play_arrow</mat-icon>
                  Watch video
               </button>
            </div>
              </div>
           </mat-card>
        </div>
       </div> -->
      <div class="col-sm-4">
         <div class="dashboard_new">
            <mat-card>
               <div class="upload_sectio">
                  <div class="icm_img">
                     <img src="./assets/images/helpsupport.png">
                  </div>
                  <mat-card-title>Facing any issue?</mat-card-title>
                  <mat-card-content>For any difficulties contact our support team.
                  </mat-card-content>
                  <div class="watch_vc_btn">
                     <button mat-stroked-button color="primary"  (click)="opencontact()">
                        <mat-icon>support_agent</mat-icon>
                        Contact support 
                     </button>
                  </div>
               </div>
            </mat-card>
         </div>
      </div>
   </div>
</div>
<!-- placeholder html end -->


<!--  QUERIES END -->